import SchemaPropTypes from '@get-bridge/learn-legacy-shared/dist/shared/SchemaPropTypes';
const { oneOf } = SchemaPropTypes;
import { TaskSource } from '../../constants';
import { values } from 'lodash';

export default oneOf(values(TaskSource));



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/schemas/TaskSource.js